<template>
    <div class="vue-algolia-nav-search" :class="active ? 'active' : ''" v-click-outside="handleClickOutside">
        <form @submit.prevent>
            <button @click="handleClick" class="search-toggle">Open de search</button>

            <div class="search-input-wrapper">
                <input ref="searchInput" v-model="searchValue" type="text" :placeholder="searchPlaceholderTxt" @keyup.enter="handleSearch">
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: "AlgoliaNavSearch",

    props: {
        langCode: {
            type: String,
            default: 'nl'
        },
        searchPageUrl: {
            type: String
        }
    },

    data() {
        return {
            searchPlaceholderTxt: window.Drupal.t('Search...'),
            searchValue: '',
            active: false,
        }
    },

    computed: {
        hasSearchValue() {
            return ! _.isEmpty(this.searchValue)
        }
    },

    methods: {
        handleClick() {
            if (this.hasSearchValue) {
                this.goToSearchPage();
                return;
            }
            this.active = ! this.active;

            this.checkFocus();
        },

        handleSearch() {
            if (!this.hasSearchValue) {
                return;
            }

            this.goToSearchPage();
        },

        checkFocus() {
            if (this.hasSearchValue && !this.active) {
                return;
            }

            let input = this.$refs.searchInput;

            setTimeout(() => {
                input.focus();
            }, 200)
        },

        handleClickOutside() {
            this.active = false;
            this.searchValue = '';
        },

        goToSearchPage() {
            window.location = `${this.searchPageUrl}?vneml_prod_${this.langCode}[query]=${this.searchValue}`;
        }
    }
}
</script>